// Utility to get meeting types for Schedule Meeting page
export function getMeetingTypesForSchedule({
  meetings,
  login,
  selectedOrganization,
}) {
  const isGlobalAdmin = login?.data?.role === "global admin";
  const isOrgAdmin = login?.data?.role === "orgadmin";
  const userOrgId = isGlobalAdmin ? "0" : login?.data?.orgId || "0";
  if (isGlobalAdmin) {
    if (selectedOrganization === "All Organisation") return [];
    return meetings.filter(
      (m) => m.orgId === selectedOrganization || m.orgId === "0"
    );
  } else if (isOrgAdmin) {
    return meetings.filter((m) => m.orgId === userOrgId);
  }
  // Advisor or other user: only show their org's meeting types
  return meetings.filter((m) => m.orgId === userOrgId);
}

// Utility to get empty dropdown message and redirect logic
export function getMeetingTypeDropdownState({
  meetingTypes,
  login,
  redirectToManageMeeting,
}) {
  const isAdmin = ["global admin", "orgadmin"].includes(login?.data?.role);
  if (meetingTypes.length === 0) {
    if (isAdmin) {
      // Redirect to Manage Meeting page
      if (redirectToManageMeeting) redirectToManageMeeting();
      return {
        message:
          "No meeting types are configured by Admin. Redirecting to Manage Meeting page...",
        showContactAdmin: false,
      };
    } else {
      return {
        message: "No meeting types are configured by Admin. Contact Admin.",
        showContactAdmin: true,
      };
    }
  }
  return { message: "", showContactAdmin: false };
}
